import '@mdi/font/css/materialdesignicons.css'
// eslint-disable-next-line import/no-extraneous-dependencies
import 'material-design-icons-iconfont/dist/material-design-icons.css'
import _ from 'lodash'
import Vue from 'vue'
import Vuetify from 'vuetify/lib'
import th from 'vuetify/lib/locale/th'
import { importAll } from '@/assets/js/utils/svg-loader'

Vue.use(Vuetify)

export default new Vuetify({
  lang: {
    locales: { th },
    current: 'th',
  },
  icons: {
    values: _.assign(
      importAll(require.context('@/assets/svg/icons/', true, /\.svg$/), 'snt')
    ),
  },
  theme: {
    light: true,
    dark: false,
    themes: {
      light: {
        primary: '#1BA7E1',
        error: '#DE6B4F',
        success: '#19C788',
        warning: '#EDA437',
        secondary: '#6C6C6C',
        background: '#F4F6FA',
        shopee: '#F8551F',
        lazada: '#0304B0',
        tiktok: '#000000',
        lineshopping: '#43cf84',
        grey: '#B5B5B5',
        'field-grey': '#B5B5B5',
        accent: '#ff7a1a',
        'stroke-grey': '#E7E7E7',
        'primary-light': '#E7F4FC',
        'warning-light': '#FFF4DE',
        'error-light': '#FCE6E1',
        'success-light': '#DFF1EB',
      },
      dark: {
        primary: '#1BA7E1',
        error: '#F04D4D',
        success: '#2AB59C',
        warning: '#EDA437',
        secondary: '#FFFFFF',
      },
    },
    options: {
      customProperties: true,
    },
  },
})
